import { inject, Injectable, Injector } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';

import { ClientLogApiSender, ClientLogBatch, ClientLogSendOptions } from '@efficiently/client-core-logger';

import { SEND_CLIENT_LOG_BATCH_MUTATION } from '../queries';

/**
 * The batch goes out as collected: `ClientLogLevel` publishes each severity under its own runtime
 * name, so `trace` is both what the logger recorded and what the mutation accepts. Nothing here
 * translates the vocabulary.
 */
@Injectable()
export class ClientLogApiSenderService implements ClientLogApiSender {
	private readonly injector = inject(Injector);

	public async send(batch: ClientLogBatch, options?: ClientLogSendOptions): Promise<void> {
		const apollo = this.injector.get(Apollo, null);

		if (!apollo) {
			throw new Error('Apollo provider is required for client logger GraphQL transport');
		}

		const response = await firstValueFrom(
			apollo.mutate({
				mutation: SEND_CLIENT_LOG_BATCH_MUTATION,
				variables: {
					payload: batch,
				},
				context: {
					skipClientLogger: true,
					skipGlobalErrorHandler: true,
					skipRefreshOnUnauthorized: true,
					keepalive: options?.keepalive === true,
				},
			}),
		);

		if (!response.data?.sendClientLogBatch) {
			throw new Error('Client logger GraphQL mutation failed');
		}
	}
}
